import { render, staticRenderFns } from "./ActivityManage.vue?vue&type=template&id=5447a483&scoped=true"
import script from "./ActivityManage.vue?vue&type=script&lang=js"
export * from "./ActivityManage.vue?vue&type=script&lang=js"
import style0 from "./ActivityManage.vue?vue&type=style&index=0&id=5447a483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5447a483",
  null
  
)

export default component.exports